module.exports = __webpack_public_path__ + "img/2_atm_l1_l2_lr_l0.4e39ef5b.png";